module.exports = __webpack_public_path__ + "img/elevenBuyBannerBg2021.3429407a.jpg";